import React from "react"
import Input from "../../../../Input/Input"
import { setCompanyName, setCompanyNameInput } from "../../useReducer/actionCreators"

const CompanyNameInput = ({ companyNameInput, externalDispatch }) => {
  return (
    <Input
      type="text"
      name="company_name"
      label="Company Name"
      placeholder="Enter title"
      fieldStyle="black"
      value={companyNameInput || ""}
      onChange={(e) => {
        externalDispatch(setCompanyNameInput(e.target.value))
      }}
      onBlur={(e) => {
        if (e.target.value.trim()) {
          externalDispatch(setCompanyName(e.target.value.trim()))
        }
      }}
    />
  )
}
export default CompanyNameInput
